/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity, userSupportedTypes } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "fieldDefs",
    graphQL: "FieldDef",
    name: "Field Definition",
    defaultOrder: ['entityDef_id', 'key'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "fieldDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['groupDef'],
    fields: (types) => { return {
        id: {
            name: "Field Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
            isPublic: true,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            required: true,
            isPublic: true,
        },
        shortName: {
            name: "Short Name",
            type: "string",
            translatable: true,
            defaultValue: "",
            description: "Keep empty if it is same as name.",
            isPublic: true,
        },
        exampleData: {
            name: "Example data",
            type: "string",
            translatable: true,
            defaultValue: "",
            description: "It is used for rendering filled boxes with data.",
            isPublic: true,
        },
        entityDef: {
            name: "Entity",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            required: true,
            trim: true,
            validations: {
                matchRegexp: /^[a-zA-Z0-9_]+$/,
            },
            isPublic: true,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "string",
            values: userSupportedTypes,
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        defaultExpression: {
            name: "Default expression",
            type: "expression",
        },
        aliases: {
            name: "Old aliases",
            type: "object",
            defaultValue: [],
        },
        notes: {
            name: "Notes",
            type: "string",
            translatable: false,
            defaultValue: "",
            isPublic: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
